<template>
  <div class="page"></div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { codeToUserInfoGet, weChatBind } from "@/api/common";
import { STATUS_CODE_OK, TOAST_STAY_TIME } from "@/config";
export default {
  name: "UisAuth",
  computed: {
    ...mapGetters(["openId"]),
  },
  async created() {
    const that = this;
    that.toast = that.$toast.loading({
      duration: 0,
      forbidClick: true,
      message: "授权登录中",
    });
    let { path, auth, insysauthcode, bind, autologin } = that.$route.query;
    path = window.decodeURIComponent(path);
    if (auth === "1") {
      if (autologin === "Y") {
        let userInfoRes = await codeToUserInfoGet({
          authCode: insysauthcode,
        });
        if (userInfoRes.data.code === STATUS_CODE_OK) {
          that.setToken(userInfoRes.data.data.token);
          that.setBind(bind);
          that.setUserInfo(userInfoRes.data.data.userInfo);
          if (bind === "N") {
            try {
              await that.$dialog.confirm({
                title: "提示",
                message: "需要绑定微信帐号吗",
                confirmButtonText: "绑定",
                cancelButtonText: "暂不绑定",
                confirmButtonColor: "#1989fa",
              });
              let { data } = await weChatBind({
                openId: that.openId,
                bindFlag: "Y",
              });
              if (data.code === STATUS_CODE_OK) {
                that.$notify({
                  type: "success",
                  message: `欢迎回来，${userInfoRes.data.data.userInfo.realname}同学/老师`,
                  duration: TOAST_STAY_TIME,
                });
                that.setBind("Y");
                that.$router.replace({
                  path: path,
                });
              }
            } catch {
              that.$router.replace({
                path: path,
              });
            }
          } else {
            if (path == "yearReportH5") {
              // 跳转到图书馆个人年度报告
              window.location.replace(
                `https://mlibrary.fudan.edu.cn/reporth5/content`
              );
            } else if (path == "graduateReportH5") {
              // 跳转到图书馆毕业报告
              window.location.replace(
                `https://mlibrary.fudan.edu.cn/reporth5/graduatecontent`
              );
            } else {
              that.$notify({
                type: "success",
                message: `欢迎回来，${userInfoRes.data.data.userInfo.realname}同学/老师`,
                duration: TOAST_STAY_TIME,
              });
              that.$router.replace({
                path: path,
              });
            }
          }
        }
      } else {
        that.$router.replace({
          path: path,
        });
      }
    } else {
      that.$router.replace({
        path: "/500",
      });
    }
  },
  methods: {
    ...mapActions(["setToken", "setBind", "setUserInfo"]),
  },
  beforeDestroy() {
    this.toast && this.toast.clear(true);
  },
};
</script>

<style scoped lang="scss"></style>
